import {IBaseModel, BaseModel} from '../base.model'
import {BmDetailViewmodel} from "./bm-detail.viewmodel";
import {BMIBContractorViewModel} from "./bm-ib-contractor.viewmodel";
import {BmIBViewModel} from "./bm-ib.viewmodel";
import {BMParticipantViewModel} from "./bm-participant.viewmodel";
import {IBlock} from "../block";
import {IBMMeetingParameter} from "./bm-meeting.parameter";

export interface IBMMeetingDetailViewModel extends IBaseModel {
  date_start?: string,
  date_end?: string,
  date_next_meeting?: string,
  deletedAt?: string,
  generalComments?: BmIBViewModel,
  inspections?: BmIBViewModel[],
  is_archived?: boolean,
  master?: BmDetailViewmodel,
  media_pdf?: {
    link: string
  },
  participants?: BMParticipantViewModel[],
  reference?: string,
  state?: string,
  creator?: {
    id: number,
    firstname: string,
    lastname: string,
    cellphone: string,
    landline: string,
    email: string,
  }
}

export class BmMeetingDetailViewModel extends BaseModel implements IBMMeetingDetailViewModel {
  date_start: string
  date_end: string
  date_next_meeting: string
  deletedAt: string
  generalComments: BmIBViewModel
  inspections: BmIBViewModel[]
  is_archived: boolean
  master: BmDetailViewmodel
  media_pdf: {
    link: string
  }
  participants: BMParticipantViewModel[]
  reference: string
  state: string
  creator: {
    id: number,
    firstname: string,
    lastname: string,
    cellphone: string,
    landline: string,
    email: string
  }

}



// WEBPACK FOOTER //
// ./src/models/bm/bm-meeting-detail.viewmodel.ts